const breakpoints = {
    tablet: "75rem",
    mobile: "46.875rem",
}

export default breakpoints
